import React, { useEffect, useRef, useState } from "react";
import blogFetch from "../../axios/config";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextField } from "@mui/material";
import "moment/locale/pt-br";
import { getIdCompany } from "../../utils/constantes";

const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props, ref) => {
  const [description, setDescription] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTypeOcurrence();
  }, []);

  useImperativeHandle(ref, () => ({
    addTypeOcurrence,
    updateTypeOcurrence,
    deleteTypeOcurrence,
  }));

  const addTypeOcurrence = async () => {
    let data = {
      TPO_description: description,
      TPO_FK_companyId: getIdCompany(),
    };

    try {
      const response = await blogFetch.post("/typeOccurrence", data);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const updateTypeOcurrence = async () => {
    let data = {
      TPO_description: description,
      TPO_FK_companyId: getIdCompany(),
    };

    try {
      const response = await blogFetch.put(
        "/typeOccurrence/" + props.IdTypeOcurrence,
        data
      );
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getTypeOcurrence = async () => {
    if (props.IdTypeOcurrence != null) {
      try {
        setIsLoading(true);
        let response = await blogFetch.get(
          `/typeOccurrence/${props.IdTypeOcurrence}`
        );
        let data = response.data;
        setDescription(data.tpO_description);
        setIsLoading(false);
        return data;
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    }
  };

  const deleteTypeOcurrence = async () => {
    let data = {
      TPO_description: description,
      TPO_FK_companyId: getIdCompany(),
    };

    try {
      const response = await blogFetch.delete(
        "/typeOccurrence/" + props.IdTypeOcurrence
      );

      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return (
    <>
      <div className="form-floating mb-3">
        {isLoading && (
          <div className="loading-container">
            <FontAwesomeIcon icon={faSpinner} spin />
          </div>
        )}

        <TextField
          required
          fullWidth
          label="Descrição"
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
    </>
  );
});
